import React from 'react';
import { motion } from 'framer-motion';
import {
  CheckCircle,
  Sparkle,
  X
} from '@phosphor-icons/react';

/**
 * AssessmentSuccessBanner - Simple, persistent success banner
 * 
 * Shows at the top of the results page after assessment completion.
 * No modal, no timing issues, no HMR conflicts.
 */
const AssessmentSuccessBanner = ({ 
  totalOpportunities = 0, 
  onDismiss,
  isVisible = true 
}) => {
  if (!isVisible) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3 }}
      className="mb-6 relative overflow-hidden rounded-2xl"
      data-testid="assessment-success-banner"
    >
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#14F195]/20 via-[#00E5C0]/20 to-[#00E5C0]/20" />
      
      {/* Content */}
      <div className="relative px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-4">
          {/* Success icon */}
          <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#14F195] to-[#00E5C0] flex items-center justify-center flex-shrink-0">
            <CheckCircle size={24} className="text-white" />
          </div>
          
          {/* Message */}
          <div>
            <div className="flex items-center gap-2">
              <h3 className="text-xl font-bold text-white">
                <span className="text-[#14F195]">{totalOpportunities}</span> Opportunities Identified
              </h3>
              <Sparkle size={20} className="text-[#F59E0B]" />
            </div>
            <p className="text-[#A0AEC0] text-sm">
              Your assessment is complete. Review your opportunities below.
            </p>
          </div>
        </div>
        
        {/* Dismiss button */}
        <button
          onClick={onDismiss}
          className="p-2 rounded-full hover:bg-[rgba(255,255,255,0.1)] transition-colors text-[#A0AEC0] hover:text-white"
          aria-label="Dismiss banner"
          data-testid="dismiss-success-banner"
        >
          <X size={20} />
        </button>
      </div>
      
      {/* Bottom border accent */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#14F195] via-[#00E5C0] to-[#00E5C0]" />
    </motion.div>
  );
};

export default AssessmentSuccessBanner;
